import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';

import { ifProp } from '@lib/ifProp';

import { getFont } from '@styles/mixins/fonts';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

interface TextBlockWithAsideProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  aside?: React.ReactNode;
  text: React.ReactNode;
}

export const TextBlockWithAside = React.forwardRef<HTMLDivElement, TextBlockWithAsideProps>(
  ({ aside, text, className }, blockRef) => {
    const hasNoAside = aside === null || typeof aside === 'undefined';
    return (
      <Wrapper isSingletone={hasNoAside} className={className} ref={blockRef}>
        {aside}
        <TextWrapper isSingletone={hasNoAside}>{text}</TextWrapper>
      </Wrapper>
    );
  },
);

interface WrappersProps {
  isSingletone?: boolean;
}

const Wrapper = styled.div<WrappersProps>`
  position: relative;
  display: flex;
  align-items: start;
  justify-content: ${ifProp('isSingletone', 'flex-end', 'space-between')};
  width: 1045px;
  height: fit-content;

  ${getMediaqueryStyled('xl')} {
    justify-content: ${ifProp('isSingletone', 'flex-start', 'space-between')};
    width: 870px;
  }

  ${getMediaqueryStyled('lg')} {
    width: 538px;
  }

  ${getMediaqueryStyled('md')} {
    width: 100%;
  }
`;

const TextWrapper = styled.div<WrappersProps>`
  margin-left: ${ifProp('isSingletone', '0', '80px')};
  width: fit-content;
  ${getFont('main')}

  ${ifProp(
    'isSingletone',
    css`
      max-width: 805px;

      ${getMediaqueryStyled('xl')} {
        max-width: 700px;
      }

      ${getMediaqueryStyled('lg')} {
        max-width: 485px;
      }

      ${getMediaqueryStyled('md')} {
        width: 100%;
        max-width: none;
      }
    `,
  )}

  ${getMediaqueryStyled('lg')} {
    margin-left: ${ifProp('isSingletone', '0', '50px')};
  }

  ${getMediaqueryStyled('md')} {
    margin-left: 0;
  }
`;
